import { Page } from '@/core/architecture'

import { ConsoleBusinessEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleCampaignDetail Page
 * Implemented as a practical sample.
 */
export const ConsoleBusinessEdit: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleBusinessEditTemplate state={state} {...actions} />
}
